export default __webpack_public_path__ + "static/media/cloud-1.b6b46d09.webp";